<template>
    <div id="main" class="is-flex">
        <div class="page page-container">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('agenda') }}:
                            {{
                                agendaatividade && agendaatividade.idagendaatividade
                                    ? agendaatividade.titulo
                                    : $t('nova-agenda')
                            }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t('vendas') }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t('crm') }}</a>
                                </li>
                                <li>
                                    <a @click="$router.push({ name: 'venda-atividades' })">{{
                                        $t('agendas')
                                    }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        agendaatividade && agendaatividade.idagendaatividade
                                            ? agendaatividade.titulo
                                            : $t('nova-agenda')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            @click="$router.push({ name: 'venda-atividades' })"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            class="success-btn"
                            type="button"
                            v-if="
                                !agendaatividade.dataHoraFinalizado &&
                                modulopda.altera &&
                                id &&
                                permissao.update &&
                                id &&
                                !tabelaIntegracao
                            "
                            :disabled="!isUpdate || isSaving || isFinalizing"
                            @click="promptForCompletion"
                        >
                            {{ $t('finalizar') }}
                            <button-loader :isSaving="isFinalizing" />
                        </button>
                        <button
                            class="save-btn"
                            type="button"
                            @click="saveAgendaAtividade()"
                            :disabled="!isUpdate || isSaving || isFinalizing"
                            v-if="
                                !agendaatividade.dataHoraFinalizado &&
                                ((modulopda.altera && id && permissao.update && id) ||
                                    (modulopda.inclui && permissao.create)) &&
                                !tabelaIntegracao
                            "
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>

                <!-- FORMULÁRIO -->
                <div class="columns is-multiline is-2 is-variable mt-4">
                    <div
                        class="column"
                        :class="{
                            'is-full': detalhe.USUARIO && detalhe.USUARIO.oculta,
                            'is-8': detalhe.USUARIO && !detalhe.USUARIO.oculta,
                        }"
                        v-if="detalhe.TITULO && !detalhe.TITULO.oculta"
                    >
                        <v-input
                            ref="tituloInput"
                            v-model="agendaatividade.titulo"
                            :title="
                                detalhe.TITULO
                                    ? detalhe.TITULO.label || $t('titulo')
                                    : $t('titulo')
                            "
                            :maxlength="detalhe.TITULO ? detalhe.TITULO.maxlength || 255 : 255"
                            :disabled="
                                !isUpdate ||
                                !!agendaatividade.dataHoraFinalizado ||
                                !(modulopda.inclui || modulopda.altera) ||
                                !(permissao.create || permissao.update) ||
                                tabelaIntegracao
                            "
                            :invalid="checkInvalid('TITULO', agendaatividade.titulo)"
                            disableMLtitle
                            :required="true"
                        />
                    </div>
                    <div
                        class="column"
                        :class="{
                            'is-full': detalhe.TITULO && detalhe.TITULO.oculta,
                            'is-4': detalhe.TITULO && !detalhe.TITULO.oculta,
                        }"
                        v-if="detalhe.USUARIO && !detalhe.USUARIO.oculta"
                    >
                        <vss-select
                            v-if="id == null"
                            ref="usuarioSelect"
                            label="nome"
                            v-model="colaboradorSelected"
                            :title="
                                detalhe.USUARIO
                                    ? detalhe.USUARIO.label || $t('colaboradores')
                                    : $t('colaboradores')
                            "
                            :options="colaboradorSelect"
                            :loading="colaboradoresLoading"
                            :disabled="
                                !isUpdate ||
                                !!agendaatividade.dataHoraFinalizado ||
                                !(modulopda.inclui || modulopda.altera) ||
                                !(permissao.create || permissao.update) ||
                                tabelaIntegracao
                            "
                            :invalid="colaboradorSelected.length == 0"
                            @search="carregarColaboradores"
                            searchable
                            multiple
                            :close-on-select="false"
                            disableMLtitle
                        />
                        <vss-select
                            v-else
                            ref="usuarioSelect"
                            label="nome"
                            v-model="agendaatividade.colaborador"
                            :title="
                                detalhe.USUARIO
                                    ? detalhe.USUARIO.label || $t('colaborador')
                                    : $t('colaborador')
                            "
                            :options="colaboradorSelect"
                            :loading="colaboradoresLoading"
                            :disabled="
                                !isUpdate ||
                                !!agendaatividade.dataHoraFinalizado ||
                                id != null ||
                                !(modulopda.inclui || modulopda.altera) ||
                                !(permissao.create || permissao.update) ||
                                tabelaIntegracao
                            "
                            :invalid="agendaatividade.colaborador == null"
                            @search="carregarColaboradores"
                            searchable
                            :close-on-select="false"
                            disableMLtitle
                        />
                    </div>
                </div>
                <div class="columns is-multiline is-2 is-variable">
                    <div
                        class="column is-one-third"
                        v-if="detalhe.TIPOAGENDAATIVIDADE && !detalhe.TIPOAGENDAATIVIDADE.oculta"
                    >
                        <vss-select
                            ref="tipoAtividadeInput"
                            v-model="agendaatividade.tipo"
                            label="descricao"
                            :title="
                                detalhe.TIPOAGENDAATIVIDADE
                                    ? detalhe.TIPOAGENDAATIVIDADE.label || $t('tipo')
                                    : $t('tipo')
                            "
                            :options="tiposAtividades"
                            :loading="tiposLoading"
                            :disabled="
                                !isUpdate ||
                                !!agendaatividade.dataHoraFinalizado ||
                                !(modulopda.inclui || modulopda.altera) ||
                                !(permissao.create || permissao.update) ||
                                tabelaIntegracao
                            "
                            :invalid="checkInvalid('TIPOAGENDAATIVIDADE', agendaatividade.tipo)"
                            @search="carregarTipos"
                            searchable
                            disableMLtitle
                        />
                    </div>
                    <div
                        class="column is-one-third is-flex"
                        v-if="detalhe.DATAINICIO && !detalhe.DATAINICIO.oculta"
                    >
                        <v-input
                            class="is-100"
                            ref="inicioInput"
                            :title="$t('data-inicio')"
                            v-model="dataIni"
                            :disabled="
                                !isUpdate ||
                                !!agendaatividade.dataHoraFinalizado ||
                                !(modulopda.inclui || modulopda.altera) ||
                                !(permissao.create || permissao.update) ||
                                tabelaIntegracao
                            "
                            :invalid="checkInvalid('datainicio', agendaatividade.datainicio)"
                            disableMLtitle
                            @onBlurFunction="inputDataInicio()"
                        />
                        <div class="ml-3">
                            <label>{{ $t('hora-inicio') }}</label>
                            <!-- @71446 - Inserido o componente de hora -->
                            <vue-timepicker
                                hide-clear-button
                                class="full-width"
                                close-on-complete
                                manual-input
                                :manual-input-timeout="1000"
                                v-model="iniciocaptura"
                                :disabled="
                                    !isUpdate ||
                                    !!agendaatividade.dataHoraFinalizado ||
                                    !(modulopda.inclui || modulopda.altera) ||
                                    !(permissao.create || permissao.update) ||
                                    tabelaIntegracao
                                "
                                @input="inputHoraInicio()"
                            />
                        </div>
                        <div
                            class="buttons has-addons is-flex-nowrap ml-3 regular-altura"
                            v-if="
                                !agendaatividade.dataHoraFinalizado &&
                                (modulopda.inclui ||
                                    (modulopda.altera &&
                                        id)) /* verifica se modulo pda permite incluir ou editar, editar precisa do id */ &&
                                (permissao.create ||
                                    (permissao.update &&
                                        id)) /* verifica permissao da tela para criar ou editar, editar precisa do id  */ &&
                                !tabelaIntegracao /* verifica se esta na tabela integracao */
                            "
                        >
                            <b-button
                                class="mb-0"
                                type="is-primary"
                                icon-right="calendar"
                                @click="openModalInicio"
                            />
                            <b-button
                                class="mb-0"
                                type="is-light"
                                icon-right="close"
                                @click="removeData"
                            />
                        </div>
                    </div>
                    <div
                        class="column is-one-third is-flex"
                        v-if="detalhe.DATAFIM && !detalhe.DATAFIM.oculta"
                    >
                        <v-input
                            class="is-100"
                            ref="fimInput"
                            :title="$t('data-fim')"
                            v-model="dataFim"
                            :disabled="
                                !isUpdate ||
                                !!agendaatividade.dataHoraFinalizado ||
                                !(modulopda.inclui || modulopda.altera) ||
                                !(permissao.create || permissao.update) ||
                                tabelaIntegracao
                            "
                            :invalid="checkInvalid('datafim', agendaatividade.datafim)"
                            @onBlurFunction="inputDataFim()"
                            disableMLtitle
                        />

                        <div class="ml-3">
                            <label>{{ $t('hora-fim') }}</label>
                            <!-- @71446 - Inserido o componente de hora -->
                            <vue-timepicker
                                close-on-complete
                                hide-clear-button
                                class="full-width"
                                manual-input
                                :manual-input-timeout="1000"
                                v-model="terminocaptura"
                                :disabled="
                                    !isUpdate ||
                                    !!agendaatividade.dataHoraFinalizado ||
                                    !(modulopda.inclui || modulopda.altera) ||
                                    !(permissao.create || permissao.update) ||
                                    tabelaIntegracao
                                "
                                @input="debounceHora()"
                            />
                        </div>

                        <div
                            class="buttons has-addons is-flex-nowrap ml-3 regular-altura"
                            v-if="
                                !agendaatividade.dataHoraFinalizado &&
                                (modulopda.inclui ||
                                    (modulopda.altera &&
                                        id)) /* verifica se modulo pda permite incluir ou editar, editar precisa do id */ &&
                                (permissao.create ||
                                    (permissao.update &&
                                        id)) /* verifica permissao da tela para criar ou editar, editar precisa do id  */ &&
                                !tabelaIntegracao /* verifica se esta na tabela integracao */
                            "
                        >
                            <b-button
                                class="mb-0"
                                type="is-primary"
                                icon-right="calendar"
                                @click="openModalFim"
                            />
                            <b-button
                                class="mb-0"
                                type="is-light"
                                icon-right="close"
                                @click="removeData"
                            />
                        </div>
                    </div>
                </div>
                <div class="columns is-multiline is-2 is-variable">
                    <div
                        class="column"
                        style="margin-bottom: 10px !important"
                        :class="{
                            'is-full': detalhe.PROPRIEDADE && detalhe.PROPRIEDADE.oculta,
                            'is-half': detalhe.PROPRIEDADE && !detalhe.PROPRIEDADE.oculta,
                        }"
                        v-if="detalhe.CLIENTE && !detalhe.CLIENTE.oculta"
                    >
                        <vss-select
                            ref="clienteInput"
                            label="rsocial"
                            v-model="agendaatividade.cliente"
                            :title="
                                detalhe.CLIENTE
                                    ? detalhe.CLIENTE.label || $t('cliente')
                                    : $t('cliente')
                            "
                            :options="clientes"
                            :loading="clientesLoading"
                            :disabled="
                                !isUpdate ||
                                !!agendaatividade.dataHoraFinalizado ||
                                !(modulopda.inclui || modulopda.altera) ||
                                !(permissao.create || permissao.update) ||
                                tabelaIntegracao
                            "
                            :invalid="checkInvalid('CLIENTE', agendaatividade.cliente)"
                            @search="carregarClientes"
                            @input="carregarClientes('')"
                            searchable
                            disableMLtitle
                        />
                    </div>
                    <div
                        class="column is-half"
                        v-if="
                            property &&
                            detalhe.PROPRIEDADE &&
                            !detalhe.PROPRIEDADE.oculta &&
                            detalhe.CLIENTE &&
                            !detalhe.CLIENTE.oculta
                        "
                    >
                        <vss-select
                            ref="propriedadeInput"
                            v-model="agendaatividade.propriedade"
                            label="nome"
                            :title="
                                detalhe.PROPRIEDADE
                                    ? detalhe.PROPRIEDADE.label || $t('propriedade')
                                    : $t('propriedade')
                            "
                            :options="propriedades"
                            :loading="propriedadesLoading"
                            :disabled="
                                !isUpdate ||
                                !!agendaatividade.dataHoraFinalizado ||
                                !agendaatividade.cliente ||
                                propriedades.length == 0 ||
                                !(modulopda.inclui || modulopda.altera) ||
                                !(permissao.create || permissao.update) ||
                                tabelaIntegracao
                            "
                            :invalid="
                                checkInvalid(
                                    'PROPRIEDADE',
                                    detalhe.CLIENTE.oculta ? false : agendaatividade.propriedade
                                )
                            "
                            :placeholder="
                                agendaatividade.cliente && propriedades.length > 0
                                    ? ''
                                    : $t('msg-preencher-campo-n', 
                                            { 
                                                n: detalhe.CLIENTE
                                                    ? detalhe.CLIENTE.label || $t('cliente')
                                                    : $t('cliente') 
                                            }
                                        )
                            "
                            @search="carregarPropriedades"
                            searchable
                            disableMLtitle
                            disableMLplaceholder
                        />
                    </div>
                </div>
                <div class="columns">
                    <div
                        class="column is-full"
                        style="padding-top: 8px !important"
                        v-if="detalhe.DESCRICAO && !detalhe.DESCRICAO.oculta"
                    >
                        <v-textarea
                            ref="descricaoTextArea"
                            class="ta-desc-atividade"
                            v-model.trim="agendaatividade.descricao"
                            :title="
                                detalhe.DESCRICAO
                                    ? detalhe.DESCRICAO.label || $t('descricao')
                                    : $t('descricao')
                            "
                            :maxlength="
                                detalhe.DESCRICAO ? detalhe.DESCRICAO.maxlength || 255 : 255
                            "
                            :invalid="checkInvalid('DESCRICAO', agendaatividade.descricao)"
                            :disabled="
                                !isUpdate ||
                                !!agendaatividade.dataHoraFinalizado ||
                                !(modulopda.inclui || modulopda.altera) ||
                                !(permissao.create || permissao.update) ||
                                tabelaIntegracao
                            "
                            disableMLtitle
                        />
                    </div>
                </div>

                <!-- DATE PICKER DATA INICIAL -->
                <b-modal :active="modalIni" @close="modalIni = false">
                    <div class="modal-card modal-default">
                        <section class="modal-card-body">
                            <div class="listing-header">
                                <div class="title-breadcrumb">
                                    <h1 class="title">{{ $t('definir-data-inicio') }}</h1>
                                </div>
                                <div class="header-buttons">
                                    <button
                                        class="delete-btn"
                                        type="button"
                                        @click="modalIni = false"
                                    >
                                        {{ $t('cancelar') }}
                                    </button>
                                    <button class="save-btn" type="button" @click="saveInicio">
                                        {{ $t('salvar') }}
                                    </button>
                                </div>
                            </div>
                            <date-time-picker class="mt-4" v-model="ini" />
                        </section>
                    </div>
                </b-modal>

                <!-- DATE PICKER DATA FINAL -->
                <b-modal :active="modalFim" @close="modalFim = false">
                    <div class="modal-card modal-default">
                        <section class="modal-card-body">
                            <div class="listing-header">
                                <div class="title-breadcrumb">
                                    <h1 class="title">{{ $t('definir-data-fim') }}</h1>
                                </div>
                                <div class="header-buttons">
                                    <button
                                        class="delete-btn"
                                        type="button"
                                        @click="modalFim = false"
                                    >
                                        {{ $t('cancelar') }}
                                    </button>
                                    <button class="save-btn" type="button" @click="saveFim">
                                        {{ $t('salvar') }}
                                    </button>
                                </div>
                            </div>
                            <date-time-picker class="mt-4" v-model="fim" />
                        </section>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
import DateTimePicker from '@/components/shared/form/DateTimePicker';
import AgendaAtividadeService from '@/services/AgendaAtividadeService';
import ColaboradorService from '@/services/ColaboradorService';
import VendasClienteService from '@/services/VendasClienteService';
import TipoAgendaAtividadeService from '@/services/TipoAgendaAtividadeService';
import PropriedadeService from '@/services/agro/PropriedadeService';
import AgendaAtividadeValidation from '@/services/validations/AgendaAtividadeValidation';

export default {
    components: {
        DateTimePicker,
    },
    beforeRouteLeave(to, from, next) {
        if (this.isChanged && this.flag === 0) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    data() {
        return {
            id: null,
            property: this.hasModulo('PROPRIEDADE'),
            service: new AgendaAtividadeService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            venClienteService: new VendasClienteService(this.$http, this.$router),
            tipoService: new TipoAgendaAtividadeService(this.$http, this.$router),
            proprService: new PropriedadeService(this.$http, this.$router),
            validation: new AgendaAtividadeValidation(
                this.$root.msgs,
                this.getModulo('AGENDAATIVIDADE')
            ),
            tabelaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('AGENDAATIVIDADE'),
            isSaving: false,
            isFinalizing: false,
            detalhe: {},
            agendaatividade: {
                datainicio: null,
                datafim: null,
                colaborador: null,
                propriedade: null,
            },
            title: '',
            tiposAtividades: [],
            tiposLoading: false,
            colaboradorSelect: [],
            colaboradorSelected: [],
            colaboradoresLoading: false,
            colaboradoresStarted: false,
            clientes: [],
            clientesLoading: false,
            propriedades: [],
            propriedadesLoading: false,
            modalIni: false,
            ini: new Date(),
            modulopda: null,
            modalFim: false,
            fim: this.$moment().add(30, 'minutes').toDate(),
            permissao: {},
            isUpdate: this.$route.params.id != null && this.$route.params.id != 'new',
            // @71446 - Variáveis de auxílio criadas
            dataIni: null,
            dataFim: null,
            debouce: null,
            iniciocaptura: { HH: '00', mm: '00' },
            terminocaptura: { HH: '00', mm: '30' },
            isChanged: false,
            agdTemp: null,
            flag: 0,
        };
    },
    
    watch: {
        agendaatividade: {
            deep: true,
            handler: function () {
                if (
                    this.agendaatividade.dataHoraFinalizado ||
                    (this.agdTemp == null &&
                        !(
                            this.tiposLoading ||
                            this.colaboradoresLoading ||
                            this.propriedadesLoading
                        ))
                ) {
                    this.agdTemp = this.agendaatividade;
                    this.isChanged = false;
                } else {
                    this.isChanged = true;
                }
            },
        },
    },
    computed: {
        allowedCreateAgenda() {
            return !this.isUpdate && this.permissao.create;
        },
        allowedUpdateAgenda() {
            return this.isUpdate && this.permissao.update;
        },
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'venda-atividades');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atividade' },
            });

        !this.isUpdate &&
            !this.allowedCreateAgenda &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atividade' },
            });

        this.getModuloPda();

        if (this.$route.params.id) {
            this.id = this.$route.params.id;
            this.carregarDados(this.id);
        } else {
            this.agendaatividade.datainicio = this.$moment(this.ini).format();
            this.agendaatividade.datafim = this.$moment(this.fim).format();
            // @71446 - Definição da variável auxiliar de data, caso seja arquivo novo
            this.dataIni = this.$moment(this.ini).format('L');
            this.dataFim = this.$moment(this.fim).format('L');
        }
        let aux = this.$moment(this.ini).format('LT').split(':');
        this.iniciocaptura.HH = aux[0];
        this.iniciocaptura.mm = aux[1];
        aux = this.$moment(this.fim).format('LT').split(':');
        this.terminocaptura.HH = aux[0];
        this.terminocaptura.mm = aux[1];
    },
    methods: {
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        getModuloPda() {
            if (this.$store.state.modulopda.disponivel && this.hasModulo('AGENDAATIVIDADE')) {
                let modulo = this.getModulo('AGENDAATIVIDADE');

                /*  Isso cria o objeto para fazer com que os MODULOPDADETALHE sejam
                    possíveis de serem acessados diretamente.
                    Ex: this.detalhe.TIPOAGENDAATIVIDADE.maxlength */
                modulo.detalhe.forEach((d) => {
                    this.$set(this.detalhe, d.campo, d);
                });

                this.modulopda = modulo;
                this.detalhe.length = modulo.detalhe.length;
            }
        },
        carregarDados(id) {
            this.$store.commit('addLoader');

            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.agendaatividade = Object.assign(body.content);
                        this.title = this.agendaatividade.descricao;
                        // Definição dos parâmetros de exibição, com base nos dados carregados
                        let aux = this.$moment(body.content.datainicio).format('LT').split(':');
                        this.iniciocaptura.HH = aux[0];
                        this.iniciocaptura.mm = aux[1];
                        aux = this.$moment(body.content.datafim).format('LT').split(':');
                        this.terminocaptura.HH = aux[0];
                        this.terminocaptura.mm = aux[1];
                        this.dataIni = this.$moment(body.content.datainicio).format('L');
                        this.dataFim = this.$moment(body.content.datafim).format('L');
                        this.carregarPropriedades('');
                    } else {
                        this.$router.push({ name: 'new-venda-atividade' });
                        this.$root.showMessage('alert', 'msg-agenda-nao-encontrada');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar agenda.', e);
                    this.$root.showMessage('error', 'msg-problema-realizar-acao');
                })
                .finally((_) => {
                    this.$store.commit('removeLoader');
                });
        },
        carregarColaboradores(q) {
            this.colaboradoresLoading = true;

            this.colaboradorService
                .findListAssociated(q)
                .then((r) => {
                    if (r.content != null) {
                        this.colaboradorSelect = r.content.map((e) => {
                            return {
                                id: e.id,
                                idusuario: e.idusuario,
                                idusuarioerp: e.idusuarioerp,
                                nome: e.nome,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de colaboradores. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.colaboradoresLoading = false;
                    if (this.id == null) {
                        let temp = this.colaboradorSelect.filter(
                            (f) => f.idusuarioerp == this.$store.state.user.idusuarioerp
                        );

                        if (q == '') {
                            if (temp.length > 0 && !this.colaboradoresStarted) {
                                this.colaboradorSelected.push(Object.assign({}, ...temp));
                                this.colaboradoresStarted = true;
                            } else if (temp.length == 0) {
                                this.carregarUsuarioAtual();
                            }
                        }
                    }
                });
        },
        carregarUsuarioAtual() {
            this.colaboradoresLoading = true;
            this.colaboradorService
                .findByErp(this.$store.state.user.idusuarioerp)
                .then((r) => {
                    let temp = {
                        id: r.content.id,
                        idusuario: r.content.idusuario,
                        idusuarioerp: r.content.idusuarioerp,
                        nome: r.content.nome,
                    };
                    this.colaboradorSelect.push(Object.assign({}, temp));
                    if (!this.colaboradoresStarted) {
                        this.colaboradorSelected.push(Object.assign({}, temp));
                    }
                })
                .catch((e) => {
                    console.error('Erro ao carregar usuário atual.', e);
                })
                .finally((_) => {
                    this.colaboradoresLoading = false;
                    this.colaboradoresStarted = true;
                });
        },

        saveAgendaAtividade(redirect = this.redirectToList) {
            this.agendaatividade = this.mapTosave(this.agendaatividade, 'datainicio', 'datafim');
            if (
                this.validation.validate(
                    this.agendaatividade,
                    this.id,
                    this.colaboradorSelected,
                    this.$refs
                )
            ) {
                this.isSaving = true;
                let data = {
                    agendaatividade: this.agendaatividade,
                    colaboradores: this.colaboradorSelected,
                };

                if (this.id) {
                    data.idagendaatividade = this.id;
                    this.update(data, redirect);
                } else {
                    this.save(data, redirect);
                }
            }
        },
        save(data, redirect) {
            this.service
                .insertBulk(data)
                .then((body) => this.exibeMensagemSalvar(body, redirect))
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-agenda-save-error');
                    this.isSaving = false;
                });
        },
        update(data, redirect) {
            this.service
                .save(data)
                .then((body) => this.exibeMensagemSalvar(body, redirect))
                .catch((e) => {
                    this.$root.showMessage('error', 'msg-agenda-save-error');
                    this.isSaving = false;
                });
        },
        exibeMensagemSalvar(body, redirect) {
            if (body.content) {
                this.$root.showMessage('success', 'msg-agenda-save-success');
                this.isChanged = false;
                redirect(2);
            } else {
                if (this.$t(body.message)) {
                    this.$root.showMessage('error', body.message);
                } else {
                    this.$root.showMessage('error', 'msg-agenda-save-error');
                }
            }
            this.isSaving = false;
        },
        redirectToList(time) {
            setTimeout((_) => {
                this.$router.push({
                    name: 'venda-atividades',
                });
            }, time * 1000 + 50);
        },
        carregarClientes(q) {
            this.clientesLoading = true;
            this.venClienteService
                .listAll(-1, q)
                .then((r) => {
                    if (r.content != null) {
                        this.clientes = r.content.map((e) => {
                            return {
                                id: e.id,
                                idcliente: e.idcliente,
                                nome: e.nome,
                                rsocial: e.rsocial,
                            };
                        });
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de clientes. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.carregarPropriedades('');
                    this.clientesLoading = false;
                });
        },
        carregarTipos(q) {
            this.tiposLoading = true;

            this.tipoService
                .findAllCombo(q)
                .then((r) => {
                    if (r.content != null) {
                        this.tiposAtividades = r.content;
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de tipos de agenda. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.tiposLoading = false;
                });
        },
        carregarPropriedades(q) {
            if (this.agendaatividade.cliente && this.agendaatividade.cliente.id) {
                let idcliente = this.agendaatividade.cliente.id;
                this.propriedadesLoading = true;

                this.proprService
                    .listAll(20, idcliente, 2, q)
                    .then((r) => {
                        if (r.content != null) {
                            this.propriedades = r.content;
                        }
                    })
                    .catch((e) => {
                        console.error(`Erro ao realizar pesquisa de propriedades. Termo: [${q}]`, e);
                    })
                    .finally((_) => {
                        this.propriedadesLoading = false;
                    });
            }
        },
        openModalInicio() {
            if (this.agendaatividade.datainicio) {
                this.ini = this.$moment(this.agendaatividade.datainicio).toDate();
            }
            this.modalIni = true;
        },
        saveInicio() {
            this.agendaatividade.datainicio = this.$moment(this.ini).format();
            let aux = this.$moment(this.agendaatividade.datainicio).format('LT').split(':');
            this.iniciocaptura.HH = aux[0];
            this.iniciocaptura.mm = aux[1];
            this.dataIni = this.$moment(this.agendaatividade.datainicio).format('L');
            this.inputDataInicio(true); // True necessário para não verificar a hora neste método
            this.inputHoraInicio();
            this.modalIni = false;
        },
        removeData() {
            // Definição dos dados de inicio
            this.ini = new Date();
            this.agendaatividade.datainicio = this.$moment(this.ini).format();
            this.dataIni = this.$moment(this.agendaatividade.datainicio).format('L');
            let aux = this.$moment(this.agendaatividade.datainicio).format('LT').split(':');
            this.iniciocaptura.HH = aux[0];
            this.iniciocaptura.mm = aux[1];
            // Definição dos dados de fim
            this.fim = this.$moment().add(30, 'minutes').toDate();
            this.agendaatividade.datafim = this.$moment(this.fim).format();
            this.dataFim = this.$moment(this.agendaatividade.datafim).format('L');
            aux = this.$moment(this.agendaatividade.datafim).format('LT').split(':');
            this.terminocaptura.HH = aux[0];
            this.terminocaptura.mm = aux[1];
        },
        openModalFim() {
            if (this.agendaatividade.datafim) {
                this.fim = this.$moment(this.agendaatividade.datafim).toDate();
            }
            this.modalFim = true;
        },
        saveFim() {
            this.agendaatividade.datafim = this.$moment(this.fim).format();
            let aux = this.$moment(this.agendaatividade.datafim).format('LT').split(':');
            this.terminocaptura.HH = aux[0];
            this.terminocaptura.mm = aux[1];
            this.dataFim = this.$moment(this.agendaatividade.datafim).format('L');
            this.inputDataFim(true); // True necessário para não verificar a hora neste método
            this.inputHoraFim();
            this.modalFim = false;
        },
        checkInvalid(campo, input) {
            let obrigainclusao;
            if (this.detalhe[campo]) {
                obrigainclusao = !!this.detalhe[campo].obrigainclusao;
            } else {
                /*  Se não existir MODULOPDADETALHE, fazer verificação manual.
                    Os campos no switch-case são NOT NULL no banco, então obrigá-los sempre */
                obrigainclusao = campo == 'TITULO';
            }
            if (obrigainclusao) {
                if (typeof input == 'string') {
                    return !input.trim();
                } else {
                    return !input;
                }
            } else {
                return false;
            }
        },
        promptForCompletion() {
            this.$root.confirm({
                message: this.$t(
                    'msg-confirm-finalizar-atividade-n', 
                    { n: this.agendaatividade.titulo }
                ),
                onConfirm: this.finalizar,
            });
        },
        finalizar() {
            this.isFinalizing = true;

            this.service
                .execute(this.id)
                .then((r) => {
                    this.carregarDados(this.id);
                    this.$root.showMessage('success', 'msg-agenda-executada-success');
                })
                .catch((e) => {
                    console.error('Erro ao executar tarefa.', e);
                    this.$root.showMessage('error', 'msg-agenda-executada-error');
                })
                .finally((_) => {
                    this.isChanged = false;
                    this.isFinalizing = false;
                });
        },
        // @71446 - Atualizar os campos de hora
        inputHoraInicio() {
            // Operator é o helper para fazer a atualização da hora
            let operator = this.$moment(this.agendaatividade.datainicio).format('LT').split(':');
            this.agendaatividade.datainicio = this.$moment(
                this.agendaatividade.datainicio
            ).subtract(operator[0], 'hour');
            this.agendaatividade.datainicio = this.$moment(
                this.agendaatividade.datainicio
            ).subtract(operator[1], 'minute');
            this.agendaatividade.datainicio = this.$moment(this.agendaatividade.datainicio)
                .add(this.iniciocaptura.HH, 'hour')
                .toDate();
            this.agendaatividade.datainicio = this.$moment(this.agendaatividade.datainicio)
                .add(this.iniciocaptura.mm, 'minute')
                .toDate();

            // Comparação se data inicial é maior que data final
            if (
                this.$moment(this.agendaatividade.datainicio).format() >
                this.$moment(this.agendaatividade.datafim).format()
            ) {
                if (this.iniciocaptura.mm > 30 && this.iniciocaptura.HH > 22) {
                    this.dataFim = this.$moment(this.agendaatividade.datafim)
                        .add(1, 'day')
                        .format('L');
                    this.inputDataFim();
                }
                let aux = this.$moment(this.agendaatividade.datainicio)
                    .add(30, 'minutes')
                    .format('LT')
                    .split(':');
                this.terminocaptura.HH = aux[0];
                this.terminocaptura.mm = aux[1];
                this.agendaatividade.datafim = this.$moment(this.agendaatividade.datainicio)
                    .add(30, 'minutes')
                    .format();
            }
        },
        // @71446 - Atualizar os campos de hora
        inputHoraFim() {
            // Operator é o helper para fazer a atualização da hora
            let operator = this.$moment(this.agendaatividade.datafim).format('LT').split(':');
            this.agendaatividade.datafim = this.$moment(this.agendaatividade.datafim).subtract(
                operator[0],
                'hour'
            );
            this.agendaatividade.datafim = this.$moment(this.agendaatividade.datafim).subtract(
                operator[1],
                'minute'
            );
            this.agendaatividade.datafim = this.$moment(this.agendaatividade.datafim)
                .add(this.terminocaptura.HH, 'hour')
                .toDate();
            this.agendaatividade.datafim = this.$moment(this.agendaatividade.datafim)
                .add(this.terminocaptura.mm, 'minute')
                .toDate();

            // Comparação se data inicial é maior que data final
            if (
                this.$moment(this.agendaatividade.datainicio).format() >
                this.$moment(this.agendaatividade.datafim).format()
            ) {
                if (this.terminocaptura.mm < 30 && this.terminocaptura.HH < 1) {
                    this.dataIni = this.$moment(this.agendaatividade.datafim)
                        .subtract(1, 'day')
                        .format('L');
                    this.inputDataInicio();
                }
                let aux = this.$moment(this.agendaatividade.datafim)
                    .subtract(30, 'minutes')
                    .format('LT')
                    .split(':');
                this.iniciocaptura.HH = aux[0];
                this.iniciocaptura.mm = aux[1];
                this.agendaatividade.datainicio = this.$moment(this.agendaatividade.datafim)
                    .subtract(30, 'minutes')
                    .format();
            }
        },
        // @71446 - Atualizar o campo de data
        inputDataInicio(flag) {
            let param = false;
            if (flag) {
                param = flag;
            }
            this.dataIni = this.verificarDataFormat(this.dataIni);
            // Operator é o helper para fazer a atualização da hora
            let operator = this.dataIni.split('/');
            this.agendaatividade.datainicio = this.$moment(this.agendaatividade.datainicio)
                .set('year', parseInt(operator[2]))
                .format();
            this.agendaatividade.datainicio = this.$moment(this.agendaatividade.datainicio)
                .set('month', parseInt(operator[1]) - 1)
                .format();
            this.agendaatividade.datainicio = this.$moment(this.agendaatividade.datainicio)
                .set('date', parseInt(operator[0]))
                .format();

            // Comparação se a dataIni é menor que a dataFim
            if (this.dataIni > this.dataFim) {
                this.dataFim = this.$moment(this.agendaatividade.datainicio).format('L');
                this.agendaatividade.datafim = this.$moment(this.agendaatividade.datafim)
                    .set('year', parseInt(operator[2]))
                    .format();
                this.agendaatividade.datafim = this.$moment(this.agendaatividade.datafim)
                    .set('month', parseInt(operator[1]) - 1)
                    .format();
                this.agendaatividade.datafim = this.$moment(this.agendaatividade.datafim)
                    .set('date', parseInt(operator[0]))
                    .format();
            }
            if (
                this.$moment(this.agendaatividade.datainicio).format() >
                    this.$moment(this.agendaatividade.datafim).format() &&
                param === false
            ) {
                this.inputHoraInicio();
            }
        },
        // @71446 - Atualizar o campos de data
        inputDataFim(flag) {
            let param = false;
            if (flag) {
                param = flag;
            }
            this.dataFim = this.verificarDataFormat(this.dataFim);
            // Operator é o helper para fazer a atualização da hora
            let operator = this.dataFim.split('/');
            this.agendaatividade.datafim = this.$moment(this.agendaatividade.datafim)
                .set('year', parseInt(operator[2]))
                .format();
            this.agendaatividade.datafim = this.$moment(this.agendaatividade.datafim)
                .set('month', parseInt(operator[1]) - 1)
                .format();
            this.agendaatividade.datafim = this.$moment(this.agendaatividade.datafim)
                .set('date', parseInt(operator[0]))
                .format();

            // Comparação se a dataFim é menor que a dataIni
            if (this.dataIni > this.dataFim) {
                this.dataIni = this.$moment(this.agendaatividade.datafim).format('L');
                this.agendaatividade.datainicio = this.$moment(this.agendaatividade.datainicio)
                    .set('year', parseInt(operator[2]))
                    .format();
                this.agendaatividade.datainicio = this.$moment(this.agendaatividade.datainicio)
                    .set('month', parseInt(operator[1]) - 1)
                    .format();
                this.agendaatividade.datainicio = this.$moment(this.agendaatividade.datainicio)
                    .set('date', parseInt(operator[0]))
                    .format();
            }
            if (
                this.$moment(this.agendaatividade.datainicio).format() >
                    this.$moment(this.agendaatividade.datafim).format() &&
                param === false
            ) {
                this.inputHoraFim();
            }
        },
        // @71446 - Método para verificar se o input feito de data é válido
        verificarDataFormat(data) {
            let anoMax = parseInt(this.$moment(this.ini).format('YYYY')) + 5;
            let anoMin = parseInt(this.$moment(this.ini).format('YYYY')) - 1;
            let operator = data.split('/');
            if (
                operator.length != 3 ||
                data === null ||
                parseInt(operator[2]) > anoMax ||
                parseInt(operator[2]) < anoMin ||
                !this.$moment(
                    `${operator[0]} ${operator[1]} ${operator[2]}`,
                    'DD MM YYYY'
                ).isValid()
            ) {
                data = this.$moment(this.ini).format('L');
                return data;
            }
            return data;
        },
        // @71446 - Função para evitar problemas ao fazer input iniciando com 0
        debounceHora() {
            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                this.inputHoraFim();
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
@import './mixins.scss';

.column {
    @include default-size-column;
}

.verified-input > span.validation {
    margin-bottom: 5px !important;
}

@media (max-width: 750px) {
    .form-buttons {
        margin-top: 140px !important;
    }
}

#main {
    padding: 0 20px 20px 20px;
    min-height: 100%;

    .page {
        position: relative;
        margin-bottom: 20px;

        .ta-desc-atividade {
            min-height: 200px;
        }
        .regular-altura button {
            margin-top: 4px;
            height: 36px;
        }
    }
}
</style>
